// Dashboard listesi widget'ı — Blazor DashboardsWidget (`api/system/DashBoardUsers/{userId}`).
import { useQuery } from '@tanstack/react-query';
import { BarChart3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { apiClient } from '@/shared/api/http/client';
import { ENDPOINTS } from '@/shared/api/endpoints';
import { queryKeys } from '@/shared/api/queryKeys';
import { useAuthStore } from '@/entities/session/model/authStore';
import { useTabsStore } from '@/features/shell/tabs/tabsStore';
import { EmptyState } from '@/shared/ui/EmptyState';
import { Spinner } from '@/shared/ui/Spinner';

interface DashboardUser {
  dashboardUserId: string;
  dashboardId: string;
  dashboard?: { dashboardId: string; dashboardName: string } | null;
}

export function DashboardsWidget() {
  const { t } = useTranslation();
  const userId = useAuthStore((s) => s.user?.userId ?? '');
  const openCustom = useTabsStore((s) => s.openCustom);
  const q = useQuery({
    queryKey: queryKeys.meta.dashboards(userId),
    queryFn: () => apiClient.get<DashboardUser[]>(ENDPOINTS.DASHBOARD_USERS(userId), { octo: { expectSuccess: false } }),
    enabled: !!userId,
    staleTime: 5 * 60_000,
  });
  if (q.isLoading) return <div className="flex h-full items-center justify-center"><Spinner /></div>;
  const items = (q.data ?? []).filter((d) => d.dashboard);
  if (!items.length) return <EmptyState title={t('home.noDashboards')} />;
  return (
    <ul className="h-full space-y-1 overflow-auto">
      {items.map((d) => (
        <li key={d.dashboardUserId}>
          <button
            type="button"
            onClick={() => openCustom({ kind: 'dashboard', caption: d.dashboard!.dashboardName, params: { dashboardId: d.dashboardId }, uniqueKey: `dashboard:${d.dashboardId}` })}
            className="hover:bg-bg-hover flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm"
          >
            <BarChart3 className="text-brand-600 h-4 w-4 shrink-0" />
            <span className="truncate">{d.dashboard!.dashboardName}</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
